<template>
    <b-container fluid>
        <b-overlay :show="customLoading" rounded="sm">
            <iq-card>
                <template v-slot:body>
                    <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                    <b-form  @submit.prevent="handleSubmit(storeTrainer)" @reset.prevent="reset" enctype="multipart/form-data">
                        <b-row>
                            <b-col xs="12" sm="12" md="12">
                                <ValidationProvider name="Photo" vid="photo" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="photo"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('trainer_trainee.attachment')}}
                                        </template>
                                        <b-form-file
                                            placeholder="Choose a file"
                                            id="customFile"
                                            v-on:change="onImageChange"
                                            accept="pdf,image.*"
                                            v-model="formData.photo"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-file>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <div class="row">
                            <div class="col text-right">
                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                             </div>
                        </div>
                    </b-form>
                    </ValidationObserver>
                </template>
            </iq-card>
        </b-overlay>
    </b-container>
</template>
<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import {
        allowanceFileUpdateApi
    } from '../../api/routes'

    export default {
        props: ['item'],
        components: {
            ValidationObserver,
            ValidationProvider
        },
        data () {
            return {
                saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.upload'),
                formData: {
                    attachment: null,
                    base64attachment: null
                },
                customLoading: false
            }
        },
        mounted () {
        },
        computed: {
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        created () {
        },
        methods: {
            onImageChange (e) {
                this.formData.attachment = e.target.files[0]
                const file = e.target.files[0]
                var reader = new FileReader()
                // eslint-disable-next-line no-return-assign
                reader.onloadend = () => this.formData.base64attachment = reader.result
                reader.readAsDataURL(file)
            },
            async storeTrainer () {
                this.customLoading = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadinState = { loading: false, listReload: true }
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${allowanceFileUpdateApi}/${this.item.id}`, this.formData)
                this.$store.dispatch('mutateCommonProperties', loadinState)
                if (result.warning) {
                    this.customLoading = false
                    this.$toast.error({
                        title: 'warning',
                        message: result.message
                    })
                    return
                }

                if (result.success) {
                    this.$store.commit('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                    this.$toast.success({
                        title: 'Success',
                        message: this.id ? 'Data updated successfully' : 'Data save successfully',
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-3')
                } else {
                    this.$refs.form.setErrors(result.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Operation failed! Please, try again.'
                    })
                }
            }
        }
    }
</script>
